// extracted by mini-css-extract-plugin
export var bgColor = "feedbacks-module--bgColor--6YEpq";
export var card = "feedbacks-module--card--3Lm99";
export var container = "feedbacks-module--container--PaqXV";
export var flex_scroll = "feedbacks-module--flex_scroll--j+1f8";
export var img = "feedbacks-module--img--6ybRl";
export var info = "feedbacks-module--info--+KuwJ";
export var info_title = "feedbacks-module--info_title--swf4H";
export var title = "feedbacks-module--title--cb93K";